import { render, staticRenderFns } from "./BookingDetailModal.vue?vue&type=template&id=cdafde02&scoped=true"
import script from "./BookingDetailModal.vue?vue&type=script&lang=js"
export * from "./BookingDetailModal.vue?vue&type=script&lang=js"
import style0 from "./BookingDetailModal.vue?vue&type=style&index=0&id=cdafde02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdafde02",
  null
  
)

export default component.exports